import React from 'react'
import styled from '@emotion/styled'
import { Menu } from './Menu'

interface Props {
  children: React.ReactNode
}

/**
 * Componente Template per il menu laterale
 * @param props.children {React.ReactNode} content della pagina
 * @component
 */
export const MenuTemplate: React.FC<Props> = (props) => {
  const { children } = props

  return (
    <Container>
      <Menu />
      <Content>
        <Scroll>{children}</Scroll>
      </Content>
    </Container>
  )
}
//region STYLE
const Container = styled.div`
  display: grid;
  grid-template-columns: 83px auto;
`
const Content = styled.div`
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
`
const Scroll = styled.div`
  width: calc(100vw - 83px);
  height: 100vh;
  overflow-y: auto;
  display: grid;
  //Scroll restyled
  ::-webkit-scrollbar-track {
    background-color: var(--background-dark-blue);
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: var(--secondary);
  }

  ::-webkit-scrollbar-corner {
    background-color: var(--secondary);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: var(--focus);
  }
`
//endregion
